module.exports = __webpack_public_path__ + "static/media/fabric-transparent.40733964.png";